<template>
<div class="div_sec">
  <el-row :gutter="60">
    <el-col :span="24" class="card-01">
      <el-row>
        <el-col :span="21" class="modal_title middle_blue">Léčba
        </el-col>
        <el-col :span="21"> <span class="modal_title green small">{{ patient.pat_surname }} {{ patient.pat_name }}</span>
        </el-col>
        <el-col :span="3" style="margin-bottom: 50px;">
          <!-- <el-button class="btn-green" icon="el-icon-plus" size="small" @click="medication_new"> Nová léčba</el-button> -->
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-table
            ref="medics_table"
            :data="medications"
            style="width: 100%; word-break: normal;"
            row-key="id_medication"
            v-loading="loading_medications"
            element-loading-text="Loading..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(211, 227, 218, 0.8)"
            :default-sort="{prop:'id_medication', order:'ascending'}"
            border
            highlight-current-row
            @sort-change="SortChange_medications"
            :stripe="true"
            >
            <el-table-column
              prop="id_medication"
              label="ID léčby"
              min-width="80"
              sortable
              >
            </el-table-column>
            <el-table-column
              prop="chem_int"
              label="Chemoterapie int."
              min-width="100"
              >
              <template slot-scope="props">
                <i v-if="props.row.chem_int" class="el-icon-check" style="color: #559f55; font-size: 15px; font-weight: 600;"></i>
                <i v-else class="el-icon-close" style="color: #9d559f; font-size: 15px; font-weight: 600;"></i>
              </template>
            </el-table-column>
            <el-table-column
              prop="udr_chem"
              label="Udržovací chem."
              min-width="100"
              >
              <template slot-scope="props">
                <i v-if="props.row.udr_chem" class="el-icon-check" style="color: #559f55; font-size: 15px; font-weight: 600;"></i>
                <i v-else class="el-icon-close" style="color: #9d559f; font-size: 15px; font-weight: 600;"></i>
              </template>
            </el-table-column>
            <el-table-column
              prop="bio_ter"
              label="Biologická ter."
              min-width="100"
              >
              <template slot-scope="props">
                <i v-if="props.row.bio_ter" class="el-icon-check" style="color: #559f55; font-size: 15px; font-weight: 600;"></i>
                <i v-else class="el-icon-close" style="color: #9d559f; font-size: 15px; font-weight: 600;"></i>
              </template>
            </el-table-column>
            <el-table-column
              prop="rad"
              label="Radioterapie"
              min-width="100"
              >
              <template slot-scope="props">
                <i v-if="props.row.rad" class="el-icon-check" style="color: #559f55; font-size: 15px; font-weight: 600;"></i>
                <i v-else class="el-icon-close" style="color: #9d559f; font-size: 15px; font-weight: 600;"></i>
              </template>
            </el-table-column>
            <el-table-column
              prop="rad_nekr"
              label="Radiační nekróza"
              min-width="100"
              >
              <template slot-scope="props">
                <i v-if="props.row.rad_nekr" class="el-icon-check" style="color: #559f55; font-size: 15px; font-weight: 600;"></i>
                <i v-else class="el-icon-close" style="color: #9d559f; font-size: 15px; font-weight: 600;"></i>
              </template>
            </el-table-column>

            <el-table-column
              width="320"
              fixed="right"
              label="Akce"
              align="right"
              >
              <template slot-scope="props">
                <el-button-group>
                  <el-button :disabled="modal_medication_ro" class="btn-blue-mid" size="mini" icon="el-icon-plus" @click="examination_new( props.$index, props.row, $event )">Diag./ud.</el-button>
                  <el-button :disabled="modal_medication_ro" class="btn-blue-mid" size="mini" icon="el-icon-plus" @click="checkup_new( props.$index, props.row, $event )">Kontrola</el-button>
                  <el-button class="btn-grey-lit" size="mini" icon="el-icon-view" @click="medication_show( props.$index, props.row, $event )"></el-button>
                  <el-button :disabled="modal_medication_ro" class="btn-grey-lit" size="mini" icon="el-icon-edit" @click="medication_edit( props.$index, props.row, $event )"></el-button>
                  <el-button :disabled="modal_medication_ro" class="btn-red-lit" size="mini" icon="el-icon-delete" @click="medication_delete( props.$index, props.row, $event )"></el-button>
                </el-button-group>
              </template>

              <!-- <template slot-scope="props">
                <el-tooltip content="Nové vyšetření" placement="top" effect="light" :open-delay="500">
                  <el-button size="small" style="background-color: #f0e4a4; margin: 5px" icon="el-icon-folder-add" @click="examination_new( props.$index, props.row, $event )" circle></el-button>
                </el-tooltip>
                <el-tooltip content="Nová kontrola" placement="top" effect="light" :open-delay="500">
                  <el-button size="small" style="background-color: #cfc5d5;  margin: 5px" icon="el-icon-view" @click="checkup_new( props.$index, props.row, $event )" circle></el-button>
                </el-tooltip>
                <el-tooltip content="Editace" placement="top" effect="light" :open-delay="500">
                  <el-button size="small" style="background-color: #becfe1; color: #815514; margin: 5px" icon="el-icon-edit" @click="medication_edit( props.$index, props.row, $event )" circle></el-button>
                </el-tooltip>
                <el-tooltip content="Delete" placement="top" effect="light" :open-delay="500">
                  <el-button size="small" style="background-color:  #e1afaf; color: #581c1c; margin: 5px" icon="el-icon-delete" @click="medication_delete( props.$index, props.row, $event )" circle>
                  </el-button>
                </el-tooltip>
              </template> -->

            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-col>
  </el-row>


</div>

</template>
<script>
  import Vue from 'vue';
  import moment from 'moment';

  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
  import axios from 'axios';

  let notifier = new Vue();

  export default {
    computed: {
      ...mapState({
        loginuser: state => state.loginuser,

        medications: state => state.medications,
        medication: state => state.medication,
        sorting_medications: state => state.sorting_medications,
        loading_medications: state => state.loading_medications,

        patient: state => state.patient,
        examination: state => state.examination,
        checkup: state => state.checkup,

        modal_medication_ro: state => state.modal_medication_ro,

      }),

      ...mapGetters({


      }),


    },


    data () {
      return {

        props: {
          multiple: false,
        },

        pickerOptions: {
          firstDayOfWeek: 1,
        },

      }
    },

    methods: {
      ...mapMutations({
        m_modal_medication: 'm_modal_medication',
        m_modal_medication_ro: 'm_modal_medication_ro',
        m_medication_by_key: 'm_medication_by_key',
        m_medication_reset: 'm_medication_reset',

        m_examination_reset: 'm_examination_reset',
        m_modal_examination: 'm_modal_examination',
        m_modal_examination_ro: 'm_modal_examination_ro',

        m_modal_checkup: 'm_modal_checkup',
        m_checkup_reset: 'm_checkup_reset',
        m_modal_checkup_ro: 'm_modal_checkup_ro',


      }),


      ...mapActions({
        a_medication: 'a_medication',
        a_medications: 'a_medications',
        a_medication_delete: 'a_medication_delete',

        a_med_cis_bio_ter_lek:  'a_med_cis_bio_ter_lek',
        a_med_cis_protokol:  'a_med_cis_protokol',
        a_med_cis_chem_int_cyt:  'a_med_cis_chem_int_cyt',
        a_med_cis_chem_int_inthe_inver_cyt:  'a_med_cis_chem_int_inthe_inver_cyt',
        a_med_cis_udr_chem_inthe_inver_cyt:  'a_med_cis_udr_chem_inthe_inver_cyt',

        a_exam_cis_sk_nadoru_get: 'a_exam_cis_sk_nadoru_get',

        }),


      medication_new() {
        this.m_medication_reset();
        this.a_med_cis_bio_ter_lek();
        this.a_med_cis_protokol();
        this.a_med_cis_chem_int_cyt();
        this.a_med_cis_chem_int_inthe_inver_cyt();
        this.a_med_cis_udr_chem_inthe_inver_cyt();
        this.medication.id_patient = this.patient.id_patient;
        this.m_modal_medication(true);
      },


      medication_show (index, row, event) {
        event.stopImmediatePropagation();
        this.m_modal_medication_ro(true);
        this.a_med_cis_bio_ter_lek();
        this.a_med_cis_protokol();
        this.a_med_cis_chem_int_cyt();
        this.a_med_cis_chem_int_inthe_inver_cyt();
        this.a_med_cis_udr_chem_inthe_inver_cyt();
        this.m_medication_reset();
        this.medication.id_medication = row.id_medication;
        this.a_medication( {'id_medication': row.id_medication} );
        this.m_modal_medication(true);
      },


      medication_edit (index, row, event) {
        event.stopImmediatePropagation();
        this.m_modal_medication_ro(false);
        this.a_med_cis_bio_ter_lek();
        this.a_med_cis_protokol();
        this.a_med_cis_chem_int_cyt();
        this.a_med_cis_chem_int_inthe_inver_cyt();
        this.a_med_cis_udr_chem_inthe_inver_cyt();
        this.m_medication_reset();
        this.medication.id_medication = row.id_medication;
        this.a_medication( {'id_medication': row.id_medication} );
        this.m_modal_medication(true);
      },


      medication_delete (index, row, event) {
        event.stopImmediatePropagation();
        this.$confirm(`Opravdu chcete položku smazat?`, 'Upozornění', {
          confirmButtonText: 'ANO',
          cancelButtonText: 'NE',
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(() => {
          this.a_medication_delete( {'id_medication': row.id_medication} );
          this.a_medications( {} );
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Smazání položky přerušeno.'
          });
        });
      },


      examination_new(index, row, event) {
        this.m_modal_examination_ro(false);
        this.m_examination_reset();
        this.examination.id_patient = this.patient.id_patient;
        this.examination.id_medication = row.id_medication;
        this.a_exam_cis_sk_nadoru_get();
        this.m_modal_examination(true);
      },


      checkup_new(index, row, event) {
        this.m_modal_checkup_ro(false);
        this.m_checkup_reset();
        this.checkup.id_patient = this.patient.id_patient;
        this.checkup.id_medication = row.id_medication;
        this.m_modal_checkup(true);
      },


      handleChange(value) {
        console.log(value);
      },


      vymaz_data(value) {
        this.medication[value] = null;
        console.log(value);
      },


      SortChange_medications(val) {
        this.sorting_medications.sorting_prop = val.prop;
        this.sorting_medications.sorting_ordering = val.order;
        this.a_medications();
      },


      tableRowClassName({row, rowIndex}) {
        if (row.status === 0) {
          return 'row_0';
        } else if (row.status === 1) {
          return 'row_0';
        } else if (row.status === 2) {
          return 'row_0';
        } else if (row.status === 3) {
          return 'row_0';
        } else if (row.status === 4) {
          return 'row_0';
        } else {
          return 'row_0';
        }
      },


      handle_unavailable (index, row, event) {
        event.stopImmediatePropagation();
        alert(`Not available in trial version.`)
      },


    },

    beforeMount () {
    },

    created () {
    },

    mounted () {

    },

    beforeDestroy () {
    },


  }
</script>

<style lang="scss" scoped>

.el-loading-spinner i {
  font-size: 70px !important;
}

.el-loading-spinner {
  top: 25% !important;
}

.el-table .td-actions{
  button.btn {
    margin-right: 5px;
  }
}

.el-table .cell{
  line-height: 20px !important;
}

.el-table td, .el-table th {
  padding: 3px 0 !important;
}

.el-table .row_0 {
  background: rgb(253, 253, 253) !important;
}

.el-table .row_1 {
  background: rgb(243, 245, 152) !important;
}

.el-table .row_2 {
  background: rgb(248, 221, 171) !important;
}

.el-table .row_3 {
  background: rgb(248, 186, 157) !important;
}

.el-table .row_4 {
  background: rgb(197, 248, 208) !important;
}

.el-table .row_9 {
  background: rgb(250, 197, 184) !important;
}

.el-table .warning-row {
  background: rgb(241, 175, 52) !important;
}

.el-table .success-row {
  background: #0ada14 !important;
}

.el-table .info-row {
  background: #8fbdf1 !important;
}

.el-select .el-input {
  width: 220px !important;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}

.el-form-item {
   margin-bottom: 0 !important;
  }

.el-select {
  padding: 0 20px 10px 0 !important;
}



</style>

